
import { PlanCard } from "./plan-card/PlanCard";
import { useProfile } from "@/hooks/useProfile";

interface PlansListProps {
  plans: any[];
  isLoading: boolean;
  getInstructorName: (item: any) => string;
}

export const PlansList = ({ plans, isLoading, getInstructorName }: PlansListProps) => {
  const { profile } = useProfile();

  if (isLoading) {
    return <div className="text-center text-muted-foreground">Cargando planes...</div>;
  }

  if (plans?.length === 0) {
    return (
      <div className="text-center text-muted-foreground">
        No se encontraron planes de entrenamiento
      </div>
    );
  }

  // Sort plans to ensure personal plan is first, followed by other plans
  const sortedPlans = [...plans].sort((a, b) => {
    // Only the original "Mi Plan Personal" should be treated as a personal plan
    const isPersonalPlanA = a.created_by === profile?.id && a.name === "Mi Plan Personal" && !a.name.includes("(Copiado)");
    const isPersonalPlanB = b.created_by === profile?.id && b.name === "Mi Plan Personal" && !b.name.includes("(Copiado)");

    // If either is a personal plan, that determines the order
    if (isPersonalPlanA && !isPersonalPlanB) return -1;
    if (!isPersonalPlanA && isPersonalPlanB) return 1;

    // If neither is a personal plan, sort by creation date
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  });

  return (
    <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
      {sortedPlans?.map((plan) => (
        <PlanCard
          key={plan.id}
          plan={plan}
          getInstructorName={getInstructorName}
          isPersonalPlan={plan.created_by === profile?.id && plan.name === "Mi Plan Personal" && !plan.name.includes("(Copiado)")}
        />
      ))}
    </div>
  );
};
